import { Modal } from '@/components/common/AppModal';
import { Button, Spinner } from 'react-bootstrap';

export function ScheduleDeleteConfirmModal({
  show,
  scheduleName,
  busy,
  onConfirm,
  onClose,
  onExited,
}: {
  show: boolean;
  scheduleName: string;
  busy: boolean;
  onConfirm: () => void;
  onClose: () => void;
  onExited?: () => void;
}) {
  return (
    <Modal
      show={show}
      onHide={busy ? () => undefined : onClose}
      onExited={onExited}
      centered
      backdrop={busy ? 'static' : true}
      keyboard={!busy}
      className="schedule-delete-confirm-modal"
      backdropClassName="schedule-delete-confirm-backdrop"
      enforceFocus
    >
      <Modal.Header closeButton={!busy}>
        <Modal.Title className="fs--1 fw-semibold mb-0">حذف زمان‌بندی</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        زمان‌بندی «{scheduleName}» حذف شود؟ این عملیات قابل برگشت نیست.
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="button"
          variant="outline-secondary"
          disabled={busy}
          onClick={onClose}
        >
          انصراف
        </Button>
        <Button
          type="button"
          variant="danger"
          disabled={busy}
          onClick={onConfirm}
        >
          {busy && (
            <Spinner
              size="sm"
              animation="border"
              className="me-2"
              style={{ width: 12, height: 12 }}
            />
          )}
          حذف
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
